<template>
  <div>
    <maturity-details v-if="stateVault === 3" :data="data" />
    <card class="flex-wrap" customClass="card-vault-details">
      <template #header>
        <div class="flex-wrap header-vault-details justify-content-between">
          <div class="d-flex" style="margin: auto 0; gap: 15px">
            <div class="card-title">vault details</div>
            <div class="card-status live" v-if="stateVault === 1">live</div>
            <div class="card-status draft" v-if="stateVault === 2">draft</div>
            <div class="card-status mature" v-if="stateVault === 3">mature</div>
            <div class="card-status archives" v-if="stateVault === 4">
              archived
            </div>
          </div>
          <div class="d-flex align-items-center" style="gap: 10px">
            <button
              v-if="stateVault === 2"
              class="btn btn-primary btn-vault-save edit"
              type="button"
            >
              start
            </button>
            <button
              v-if="stateVault === 2"
              class="btn btn-primary btn-vault-save"
              type="button"
            >
              Save draft
            </button>
            <button
              v-if="stateVault === 3"
              class="btn btn-primary btn-vault-save"
              type="button"
              :disabled="!contract_settled"
              @click="startRound"
            >
              start round
            </button>
          </div>
        </div>
      </template>
      <div class="w-100">
        <div class="cd-mtr" v-if="stateVault != 3">
          <div class="text-head">Countdown to maturity</div>
          <div class="text-body">
            <span v-if="stateVault === 1" style="color: #ee6b6b">
              {{ countdown_to_maturity }}
            </span>
            <span v-else>-</span>
          </div>
        </div>
        <b-row no-gutters class="vault-detail-bar">
          <b-col cols="12" class="">
            <b-row no-gutters>
              <b-col cols="6" class="text-left">
                Amount in vault: {{ moneyFormat(vault_value) }} USD
              </b-col>
              <b-col cols="6" class="text-right">
                Max deposits accepted: {{ moneyFormat(max_deposit) }} USD
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12">
            <b-progress
              :value="vault_value"
              :max="max_deposit"
              class="mt-2"
            ></b-progress>
          </b-col>
        </b-row>
        <!-- <b-row class="justify-content-between">
          <b-col cols="6">
            <div class="box-pending-value">
              <div class="text-head">withdrawals pending value (USD)</div>
              <div class="text-body">
                {{ withdrawals_pending_value }}
              </div>
            </div>
          </b-col>

          <b-col cols="6">
            <div class="box-pending-value">
              <div class="text-head">Deposits pending value (USD)</div>
              <div class="text-body">
                {{ deposit_pending_value }}
              </div>
            </div>
          </b-col>
        </b-row> -->
        <b-row no-gutters class="mt-3" style="row-gap: 10px">
          <b-col cols="4" class="box-list-data">
            <div class="text-head">Token</div>
            <div class="text-body">
              {{ token }}
            </div>
          </b-col>
          <b-col cols="4" class="box-list-data">
            <div class="text-head">Type</div>
            <div class="text-body">
              {{ formattingType(type) }}
            </div>
          </b-col>
          <b-col cols="4" class="box-list-data">
            <div class="text-head">Nut</div>
            <div class="text-body">
              {{ nut }}
            </div>
          </b-col>
          <b-col cols="4" class="box-list-data">
            <div class="text-head">Time Period</div>
            <div class="text-body">
              {{ time_period }}
            </div>
          </b-col>
          <b-col cols="4" class="box-list-data">
            <div class="text-head">APY (%)</div>
            <!-- <div class="text-body">+0.00</div> -->
            <div class="text-body">+{{ apy }}</div>
          </b-col>
          <b-col cols="4" class="box-list-data">
            <div class="text-head">contract address</div>
            <div class="text-body">
              <a
                :href="`${getTokenUrl(data.network)}/address/${contract_address}`"
                target="_blank"
              >
                {{ sliceAddress(contract_address) }}
              </a>
            </div>
          </b-col>
          <b-col cols="4" class="box-list-data">
            <div class="text-head">State</div>
            <div class="text-body">
               <!-- {{ optState.find((a) => a.value == stateVault).text }} -->
              <b-form-select v-if="stateVault == 3"
                @change="ChangeState()"
                v-model="stateVault"
                :options="optSelectState"
              ></b-form-select>
              <b-form-select v-else
                @change="ChangeState()"
                v-model="stateVault"
                :options="optState"
                :disabled="disabledState"
              ></b-form-select>
            </div>
          </b-col>
          <!-- <b-col cols="4" class="box-list-data">
            <div class="text-head">sub-state</div>
            <div class="text-body">
              {{ optSubState.find((a) => a.value == Substate).text }}
              <b-form-select
                v-model="SubState"
                :options="optSubState"
              ></b-form-select>
              :disabled="disabledSubState"
            </div>
          </b-col> -->
        </b-row>
      </div>
      <b-modal
        ref="start-round-warn"
        centered
        hide-footer
        title="Warning"
        content-class="content-mod"
        header-class="head-mod"
        dialog-class="dialog-mod"
        body-class="body-mod"
      >
        <div class="text-left d-flex flex-column" style="gap: 22px">
          <div class="txt-mod-vault">
            Start round without entering all the premiums? It will result in a
            lower APY
          </div>
          <div class="d-flex" style="gap: 10px; justify-content: center">
            <button
              class="btn btn-primary btn-vault-save"
              type="button"
              @click="startRoundInput"
            >
              fill
            </button>
            <button
              class="btn btn-primary btn-vault-save edit"
              type="button"
              @click="hideWarn"
            >
              cancel
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        ref="start-round-input"
        centered
        hide-footer
        title="Start Round Input"
        content-class="content-mod"
        header-class="head-mod"
        dialog-class="dialog-mod"
        body-class="body-mod"
      >
        <div class="text-left d-flex flex-column" style="gap: 22px">
          <div>
            <b-col cols="12" class="box-list-data p-0 mb-3">
              <div class="text-head mb-2 pl-2">Strike Price</div>
              <div class="text-body">
                <input
                  class="round-input"
                  v-model="strike_price"
                  type="number"
                />
              </div>
            </b-col>
            <b-col cols="12" class="box-list-data p-0 mb-3">
              <div class="text-head mb-2 pl-2">Premium Price</div>
              <div class="text-body">
                <input
                  class="round-input"
                  v-model="premium_price"
                  type="number"
                />
              </div>
            </b-col>
            <b-col cols="12" class="box-list-data p-0 mb-3">
              <div class="text-head mb-2 pl-2">Vault Min Size</div>
              <div class="text-body">
                <input
                  class="round-input"
                  v-model="vault_min_size"
                  type="number"
                />
              </div>
            </b-col>
          </div>
          <div class="d-flex" style="gap: 10px; justify-content: center">
            <button
              class="btn btn-primary btn-vault-save"
              type="button"
              @click="startingRound"
            >
              start round
            </button>
            <button
              class="btn btn-primary btn-vault-save edit"
              type="button"
              @click="hideInput"
            >
              cancel
            </button>
          </div>
        </div>
      </b-modal>
    </card>
  </div>
</template>

<script>
import maturityDetails from "./maturityDetails.vue";
import Card from "../Card.vue";
import { mapState } from "vuex";

export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  name: "Vault-Detail",
  data() {
    return {
      amount: 25,
      stateVault: 2,
      optState: [
        { value: 1, text: "LIVE" },
        { value: 2, text: "DRAFT" },
        { value: 3, text: "MATURE" },
        { value: 4, text: "ARCHIVE" },
      ],
      optSelectState: [
        { value: 3, text: "MATURE" },
        { value: 4, text: "ARCHIVE" },
      ],
      statusVault: 1,
      optStatus: [{ value: 1, text: "Covered Call" }],
      SubState: 1,
      optSubState: [
        { value: 1, text: "Open for deposit" },
        { value: 2, text: "Closed for deposit" },
      ],
      vault_id: 1,
      changeVault:null,
      token: null,
      type: null,
      nut: null,
      time_period: null,
      apy: null,
      contract_address: null,
      state: null,
      sub_state: null,
      strategy: null,
      withdrawals: null,
      risk: null,
      withdrawals_pending: 0,
      withdrawals_pending_value: 0,
      deposit_pending: 0,
      strike_price: null,
      premium_price: null,
      vault_min_size: null,
      loading: false,
    };
  },
  components: {
    Card,
    maturityDetails,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.data.vaults_type == "matured") {
        this.stateVault = 3;
      } else {
        this.stateVault = this.optState.find(
          (a) => a.text == this.data.state.toUpperCase()
        ).value;
      }
      this.token = this.data.vault_token.symbol;
      this.type = this.data.type;
      this.nut = this.data.nut;
      this.time_period = this.data.time_period;
      this.apy = this.data.apy;
      this.contract_address = this.data.contract_address;
    },
    startRound() {
      if (!this.is_premium_completed) {
        this.$refs["start-round-warn"].show();
      } else {
        this.$refs["start-round-input"].show();
        // this.initRound();
      }
    },
    startRoundInput() {
      this.$refs["start-round-input"].show();
    },
    startingRound() {
      this.initRound();
    },
    hideWarn() {
      this.$refs["start-round-warn"].hide();
    },
    ChangeState() {
    //
      this.loading = true;
      this.changeVault = this.optState.find(
          (a) => a.value == this.stateVault
        ).text.toLowerCase();
    //
      this.$store
        .dispatch("API", {
          url: `/api/vault_state`,
          method: "POST",
          id: this.$route.params.id,
          state: this.changeVault,
        })
        .then((result) => {
        //
        })
        .finally(() => (this.loading = false));
    },
    hideInput() {
      this.$refs["start-round-input"].hide();
    },
    async initRound() {
      if (!this.strike_price)
        Vue.default.toasted.error("The strike price cannot be 0");
      if (!this.premium_price)
        Vue.default.toasted.error("The premium price cannot be 0");

      await this.$store
        .dispatch("vaults/initRound", {
          contract_address: this.data.contract_address,
          strike_price: this.strike_price,
          premium_price: this.premium_price,
          vault_min_size: this.vault_min_size,
          contract_type: this.data.type,
        })
        .then((result) => {
          //
          if (!result.code) {
            this.hideInput();
            this.hideWarn();
            this.stateVault = 1;
            Vue.default.toasted.success("Round successfully started");
          }
          if (result.code == 4001) Vue.default.toasted.error(result.message);
        });
    },
  },
  watch: {
    vault(value, oldValue) {
      if (value.id != oldValue.id) {
        this.init();
      }
    },
  },
  computed: {
    ...mapState("vault_detail", ["vault"]),
    contract_settled() {
      //   return true;
      if (this.data.maturity_detail) {
        if (this.data.maturity_detail.contract_settled == "yes") {
          return true;
        }
      } else return false;
    },
    is_premium_completed() {
      if (this.data.premium_collected >= this.max_deposit) return true;
      else return false;
    },
    vault_value() {
      if (this.data.vault_detail) {
        if (this.data.type == "put_selling") {
          return parseFloat(parseFloat(this.data.vault_detail.total_deposit));
        } else {
          return parseFloat(
            parseFloat(this.data.vault_detail.total_deposit) *
              parseFloat(this.data.price)
          );
        }
      } else return 0;
    },
    max_deposit() {
      if (this.data.type == "put_selling") {
        return parseFloat(this.data.max_deposit);
      } else {
        return parseFloat(this.data.max_deposit * this.data.price);
      }
    },
    disabledSubState() {
      if (this.contract_settled) return true;
      else return false;
    },
    disabledState() {
      if (this.vaults_type != "matured") return true;
      else return false;
    },
    countdown_to_maturity() {
      if (this.data.vault_detail) {
        return this.data.vault_detail.countdown_to_maturity;
      } else {
        return "0D 0M 0H";
      }
    },
    deposit_pending_value() {
      if (this.data.vaults_type == "matured" && this.data.vault_detail)
        return this.data.vault_detail.total_deposit * this.data.price;
      else return 0;
    },
  },
};
</script>

<style lang="scss">
@import "./resources/sass/app.scss";

.card-vault-details {
  border: 1px solid #eaedf0 !important;
  border-radius: 4px !important;
  background: $primary-4;
  .header-vault-details {
    border-bottom: 1px solid #eaedf0;
    padding-bottom: 13px;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
  }
  .card-title {
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
    line-height: 27px;
    //letter-spacing: 0.04em;
    text-transform: uppercase;
    color: $primary-5;
    margin: auto 0;
  }
  .card-status {
    padding: 7px 12px;
    border-radius: 100px;
    font-family: Exo;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 13px;
    text-transform: uppercase;
    color: $primary-4;
    &.draft {
      background: #8c8c8c;
    }
    &.live {
      background: #27ae60;
    }
    &.mature {
      background: #f5a834;
    }
    &.archives {
      background: #3751ff;
    }
  }
  .cd-mtr {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    border: 1px solid #eaedf0;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: Exo;
    font-style: normal;
    color: #222222;
    text-align: center;
    padding: 11.5px 0;
    margin-bottom: 30px;
    .text-head {
      font-family: "Exo";
      color: #222222;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      text-align: center;
    }
    .text-body {
      font-weight: bold;
      font-size: 36px;
      line-height: 48px;
      text-align: center;
      letter-spacing: 0.5px;
    }
  }
  .vault-detail-bar {
    font-family: Exo;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #222222;
    margin-bottom: 27px;
  }
  .box-pending-value {
    font-family: Exo;
    font-style: normal;
    color: #222222;
    text-align: center;
    padding: 15px 6.25px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    border: 1px solid #eaedf0;
    box-sizing: border-box;
    border-radius: 4px;
    flex: 0 0 24% !important;
    .text-head {
      font-family: "Exo";
      color: #222222;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      text-align: center;
    }
    .text-body {
      font-weight: bold;
      font-size: 36px;
      line-height: 48px;
      text-align: center;
      letter-spacing: 0.5px;
      text-transform: capitalize;
    }
  }
  .box-list-data {
    font-family: Exo;
    font-style: normal;
    color: #222222;
    text-align: center;
    padding: 4px 10px 8px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    .text-head {
      font-family: "Exo";
      color: #222222;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.5px;
      text-transform: capitalize;
      text-align: left;
    }
    .text-body {
      font-weight: 900;
      font-size: 16px;
      line-height: 18px;
      text-align: left;
      text-transform: capitalize;
    }
    a,
    a:hover {
      text-decoration: none !important;
      color: #3751ff !important;
      text-transform: lowercase;
    }
  }
  .custom-select,
  .custom-selecta:active,
  .custom-select:focus {
    width: 92%;
    height: 34px;
    padding: 8px 10px;
    font-family: Exo;
    font-style: normal;
    font-weight: 900;
    font-size: 16px;
    line-height: 18px;
    text-transform: capitalize;
    color: #222222;
    background: #fff url("/icon/chevron-down.svg") no-repeat right 0.75rem
      center/8px 10px;
    border: 1px solid #b9b9b9;
    box-shadow: none !important;
    outline: none !important;
    option {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      border: 1px solid #b9b9b9;
    }
  }
  .btn-vault-save {
    width: 136px;
    height: 34px;
    border-radius: 4px !important;
    font-family: Exo !important;
    font-weight: bold !important;
    font-size: 12px !important;
    line-height: 16px !important;
    text-transform: uppercase;
    background: #27ae60 !important;
    &.edit {
      color: #27ae60 !important;
      background: $primary-4 !important;
      border: 1px solid #27ae60 !important;
    }

    &:disabled {
      background: grey !important;
    }
  }
  .progress {
    height: 10px;
    background: #c0c0c0 !important;
    mix-blend-mode: normal;
    box-shadow: inset 1.85px 1.85px 7.4px rgba(0, 0, 0, 0.25),
      inset 1.85px 1.85px 3.7px rgba(0, 0, 0, 0.25);
    border-radius: 1.85px;
    .progress-bar {
      background: #27ae60 !important;
      opacity: 0.8;
      border-radius: 1.85px;
    }
  }
}
.txt-mod-vault {
  font-family: Exo;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #2f384f;
}
.btn-vault-save {
  width: 136px;
  height: 34px;
  border-radius: 4px !important;
  font-family: Exo !important;
  font-weight: bold !important;
  font-size: 12px !important;
  line-height: 16px !important;
  text-transform: uppercase;
  background: #27ae60 !important;
  &.edit {
    color: #27ae60 !important;
    background: $primary-4 !important;
    border: 1px solid #27ae60 !important;
  }
}

.dialog-mod {
  width: 26.25vw !important;
}
.content-mod {
  background: #ffffff !important;
  box-shadow: 0px 8px 26px 1px rgba(0, 0, 0, 0.3) !important;
  border-radius: 4px !important;
  border: none !important;
  opacity: 1 !important;
}
.head-mod {
  .modal-title {
    font-family: Exo !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 21px !important;
    color: #2f384f !important;
    margin: auto 0;
  }
  .close {
    font-family: Exo !important;
    font-style: normal !important;
    font-weight: normal !important;
    color: #2f384f !important;
    font-size: 26px !important;
  }
}

.round-input {
  width: 100%;
  border: 1px solid #b9b9b9;
  border-radius: 4px;
}
</style>
